/**
 * Galeriinavigatsioon tootelehe lightbox'is.
 *
 * Taust: Dawni `product-modal` avab modaali ja märgib klikitud meedia
 * `.active` klassiga, aga lauaarvutis näitab ta KÕIKI pilte üksteise all
 * (`.product-media-modal__content > *:not(.active) { display: block }`
 * min-width: 750 päringus). Mobiilis näitab ta ainult aktiivset. Klient tahtis
 * lauaarvutis sama, mis mobiilis: üks pilt korraga, nooltega edasi-tagasi.
 *
 * CSS teeb peitmise, see fail teeb liikumise. Miks eraldi fail, mitte
 * product-modal.js muutmine: see on Dawni upstream fail ja teema uuendamisel
 * kirjutatakse ta üle; siinne lisa elab omaette ja haakub DOM-i küljest.
 *
 * Klaviatuur: ←/→ liiguvad, Esc sulgeb (viimase teeb Dawni ModalDialog ise).
 */
(() => {
  const SELECTOR = '.product-media-modal';

  class LightboxNav {
    constructor(modal) {
      this.modal = modal;
      this.content = modal.querySelector('.product-media-modal__content');
      this.prev = modal.querySelector('.product-media-modal__nav--prev');
      this.next = modal.querySelector('.product-media-modal__nav--next');
      this.counter = modal.querySelector('.product-media-modal__counter');
      if (!this.content || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));
      document.addEventListener('keydown', (e) => this.onKey(e));

      /*
        Dawn lisab `.active` klassi alles siis, kui modaal avatakse, ja teeb
        seda ilma sündmust saatmata. MutationObserver on ainus viis teada
        saada, millal aktiivne pilt vahetus — nii jääb loendur õigeks ka siis,
        kui kasutaja avab modaali kolmandalt pisipildilt.
      */
      new MutationObserver(() => this.sync()).observe(this.modal, {
        attributes: true,
        attributeFilter: ['open', 'class'],
        subtree: true,
      });
    }

    get items() {
      return Array.from(this.content.children).filter((el) => el.dataset.mediaId);
    }

    get index() {
      return this.items.findIndex((el) => el.classList.contains('active'));
    }

    step(delta) {
      const items = this.items;
      if (!items.length) return;
      const current = this.index === -1 ? 0 : this.index;
      // Ringiga: viimaselt edasi viib esimesele ja vastupidi.
      const target = (current + delta + items.length) % items.length;
      items.forEach((el, i) => el.classList.toggle('active', i === target));
      this.sync();
    }

    onKey(event) {
      if (!this.modal.hasAttribute('open')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.step(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.step(1);
      }
    }

    sync() {
      if (!this.counter) return;
      const total = this.items.length;
      const current = this.index === -1 ? 0 : this.index;
      this.counter.textContent = total ? `${current + 1} / ${total}` : '';
    }
  }

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach((modal) => {
      if (modal.dataset.lightboxNav) return;
      modal.dataset.lightboxNav = 'true';
      new LightboxNav(modal);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
